<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/section/"
    :extra-filters="{ 'sor.id': sorId, 'volume.id': volumeId }"
    data-key="sections"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="section-list"
  >
    <template #item.updated_at="{ value }">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="() => openCheckChecksum(item)">
          Check Checksum
        </v-btn>
        <v-btn text color="primary" @click="$downloadFile(item.excel)">
          Download
        </v-btn>
        <v-tooltip top :disabled="!!item.latest_pdf">
          <template #activator="{ on, attrs }">
            <v-btn
              text
              :color="item.latest_pdf ? 'primary' : 'grey'"
              @click="
                item.latest_pdf
                  ? $downloadFile(item.latest_pdf)
                  : regenSectionPdf(item)
              "
              v-on="on"
              v-bind="attrs"
            >
              PDF
              <v-icon class="mr-2" v-if="!!!item.latest_pdf"
                >mdi-file-alert
              </v-icon>
            </v-btn>
          </template>
          <span>PDF is being generated...</span>
        </v-tooltip>

        <v-btn
          text
          color="primary"
          v-if="!sorFinalised"
          @click="editItem(item)"
        >
          Edit
        </v-btn>
        <!--        <v-btn text-->
        <!--               color="primary"-->
        <!--               :to="{name: 'sor-section-detail', params: {editionId: editionId, sorId: sorId, sectionId: item.id}}">-->
        <!--          Edit-->
        <!--        </v-btn>-->
        <v-btn
          text
          color="primary"
          v-if="!sorFinalised"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import SectionPreviewModal from "@/components/section/SectionPreviewModal";
import { ACTION_TYPES } from "@/store/types";
import ImportSectionDialog from "@/components/section/ImportSectionDialog";
import ChecksumDialog from "@/components/section/ChecksumDialog.vue";

export default {
  name: "SectionList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,

    editionId: String,
    sorId: String,
    volumeId: String,
    sorFinalised: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      // {text: root.$t('section.name'), value: 'name', contains: true},
    ]);

    // Data Table
    const headers = ref([
      { text: root.$t("section.order_no"), value: "order_no" },
      { text: root.$t("section.name"), value: "name" },
      { text: root.$t("section.updated_at"), value: "updated_at" },
      { text: "", value: "actions", sortable: false },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const downloadExcel = function (item) {
      root.$downloadFile(item.excel);
    };
    const previewItem = async function (item) {
      await root.$dialog.showAndWait(SectionPreviewModal, {
        sectionId: item.id,
        width: "70vw",
        showClose: false,
        persistent: true,
        scrollable: true,
      });

      refresh();
    };
    const exportPdf = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/section/export_pdf/",
        params: {
          section_id: item.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.pdf`;
      link.click();
    };
    const editItem = async function (item) {
      const result = await root.$dialog.showAndWait(ImportSectionDialog, {
        sorId: props.sorId,
        volumeId: props.volumeId,
        replacingSection: item,
        showClose: false,
        persistent: true,
        width: 640,
      });

      if (result === true) {
        refresh();
      }
    };

    const openCheckChecksum = async function (section) {
      await root.$dialog.showAndWait(ChecksumDialog, {
        showClose: false,
        persistent: true,
        sectionId: section.id,
      });
    };

    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete Section?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/section/delete/",
          params: { section_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };
    const regenSectionPdf = async function (item) {
      if (await root.$dialog.confirm({ text: "Regenerate Section PDF?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/section/regen_pdf/",
          params: { section_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      downloadExcel,
      previewItem,
      exportPdf,
      editItem,
      deleteItem,
      regenSectionPdf,
      openCheckChecksum,
    };
  },
};
</script>

<style lang="less">
.admin-list {
  .disabled {
    text-decoration: line-through;
  }
}
</style>
